import React from 'react'
import i18next from 'i18next'
import { Helmet } from 'react-helmet-async'
import withJWTSession from 'src/enhancers/jwt_session'
import withCapabilities from 'src/enhancers/with_capabilities'
import ManageDocuments from 'src/components/documents'

const { t } = i18next

class ManageDocumentsPage extends React.Component {
  render() {
    let title = t('pages.manage_documents', 'Gestisci documenti')
    return (
      <>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={title} />
          <link rel="icon" href="/favicon.ico" />
        </Helmet>
        <ManageDocuments />
      </>
    )
  }
}
export default withJWTSession({ invalid: '/login' })(
  withCapabilities({ some: ['show_documents', 'manage_documents'] })(ManageDocumentsPage)
)
